import React, { useState } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo";
import MyLinks from '../components/urls';
import { Alert } from 'antd'
import 'antd/es/alert/style/css'
import firebase from "gatsby-plugin-firebase"
import FileUploadBox from "../components/FileUploadBox";
import { isMobile } from 'mobile-device-detect';

const UploadPage = () => {
  const [ File, setFile ] = useState(0);
  const [message, setMessage] = useState();

  const handleChange = (file) => {
    setFile(file)
  }
  const successMsg = <Alert message="File was Uploaded" type="success" showIcon banner closable/>
  const failureMsg = <Alert message="File did not upload" type="error" showIcon banner closable/>

  React.useEffect(() => {
    if (File) {
      firebase
      .storage()
      .ref()
      .child(`csvUploads/${File.name}`)
      .put(File)
      .then(res => {
        setMessage(successMsg);
      })
      .catch(err => {
        console.log(err);
        setMessage(failureMsg)
      })
    }}, [File])
 
  return (
    <Layout>
      <SEO title="Upload Page" />
      {message}
      <h2>Upload</h2>
      <p>Please use <a href={MyLinks.CSV_TEMPLATE}>this</a> csv file as a template for uploading files. </p>
  <p>After uploading, it typically takes 10-30s for the pdf to be generated. If you don't see it, please contact {isMobile ? <a href="tel:16786036179">Jonathon</a> : <a href="mailto:jonathon.chambers@gscs.org">Jonathon</a>}</p>

      <FileUploadBox action={handleChange} />
      

    </Layout>
  )}
export default UploadPage;